$('body').on('click', '.add-canned-message-trigger', function () {
    openModal('.add-canned-message');
    return false;
});

$("body").on("click", ".open-canned-message-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".canned-message-menu-wrapper");

    $(".canned-message-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".canned-message-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".canned-message-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-canned-message-trigger', function() {
    var data = $(this).parents('.canned-message');
    var action = $('.edit-canned-message form').attr('data-action').replace('{canned_message}', data.attr('data-canned_message'));
    $('.edit-canned-message form').attr('action', action);

    $('.edit-canned-message [name="name"]').val(data.attr('data-name'));
    $('.edit-canned-message [name="message"]').val(data.attr('data-message'));

    openModal('.edit-canned-message');
    closeDropdown();
    return false;
});

$('body').on('click', '.duplicate-canned-message-trigger', function () {
    var data = $(this).parents('.canned-message');

    $('.add-canned-message [name="name"]').val(data.attr('data-name'));
    $('.add-canned-message [name="message"]').val(data.attr('data-message'));

    openModal('.add-canned-message');
    closeDropdown();
    return false;
});

$('body').on('submit', '.add-canned-message form, .edit-canned-message form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-canned-message', function(data) {
    // console.log(data);
    var element;

    if($('.canned-message[data-canned_message="'+data.canned_message+'"]').length) {
        element = $('.canned-message[data-canned_message="'+data.canned_message+'"]');

        element.attr('data-name', data.name);
        element.attr('data-message', data.message);
        
        element.find('[data-input="name"]').html(data.name);
        element.find('.canned-message-menu').html(buttons(data.buttons));
        return;
    }

    if ($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'canned-message',
            'data-canned_message': data.canned_message,
            'data-name': data.name,
            'data-message': data.message
        });

        element.append(`<td name="name">${data.name}</td>
        <td class="canned-message-menu-wrapper menu-wrapper" data-dropdown="canned-message-${data.canned_message}">
            <a href="" class="icon-more open-canned-message-menu open-menu"></a>
            <ul class="canned-message-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.canned-messages tbody').prepend(element);
    }
});